import { createFileRoute } from "@tanstack/react-router";

import { CycleView } from "../../../features/cycles/CycleView";

export const Route = createFileRoute("/_app/cycles/$cycleId")({
  /** A link can name a publication that failed for good, whose gesture to reschedule it opens. */
  validateSearch: (search: Record<string, unknown>): { reschedule?: string } =>
    typeof search["reschedule"] === "string" ? { reschedule: search["reschedule"] } : {},
  component: function CycleRoute() {
    const { cycleId } = Route.useParams();
    return <CycleView key={cycleId} cycleId={cycleId} />;
  },
});
